import React, { useEffect, useState } from "react";
import Chip from "@mui/material/Chip";
import { API } from "../App";
import { Link, useParams } from "react-router-dom";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import BasicTable from "../components/BasicTable";
import StarIcon from "@mui/icons-material/Star";

function TorneoDetails({ showPositions }) {
  const { fifaId, competitionName } = useParams();
  const [matches, setMatches] = useState([]);
  const [currentMatches, setCurrentMatches] = useState([]);
  const [matchDays, setMatchDays] = useState([]);
  const [currentDates, setCurrentDates] = useState([]);
  const [currentDate, setCurrentDate] = useState(1);
  const [ranking, setRanking] = useState([]);
  const getMatches = async () => {
    try {
      const response = await fetch(`${API}/torneos/${fifaId}/partidos`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage["tk"]}`,
        },
      }).then((res) => res.json());
      const rawMatches = response.map((match) => {
        const months = [
          "Enero",
          "Febrero",
          "Marzo",
          "Abril",
          "Mayo",
          "Junio",
          "Julio",
          "Agosto",
          "Septiembre",
          "Octubre",
          "Noviembre",
          "Diciembre",
        ];
        const rawDate = new Date(match.dateTimeLocal),
          year = rawDate.getFullYear(),
          month = months[rawDate.getMonth()],
          day = rawDate.getDate();
        if (!match.dateTimeLocal) {
          return { ...match, dateTimeLocal: "Fecha a definir" };
        } else {
          return { ...match, dateTimeLocal: `${day} de ${month} de ${year}` };
        }
      });
      setMatches(rawMatches);
      setMatchDays([...new Set(rawMatches.map((match) => match.matchDay))]);
      setCurrentMatches([
        ...rawMatches.filter(
          (match) => match.matchDay === rawMatches[0]?.matchDay
        ),
      ]);
      setCurrentDates([
        ...new Set(
          rawMatches
            .filter((match) => match.matchDay === rawMatches[0]?.matchDay)
            .map((cm) => {
              return cm.dateTimeLocal;
            })
        ),
      ]);
    } catch (error) {
      console.log(error);
    }
  };
  const getRanking = async () => {
    try {
      const response = await fetch(
        `${API}/torneos/${fifaId}/tabla-posiciones`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${localStorage["tk"]}`,
          },
        }
      ).then((res) => res.json());
      setRanking(response);
    } catch (error) {
      console.log(error);
    }
  };
  const handleChipClick = (date) => {
    setCurrentMatches([...matches.filter((match) => match.matchDay === date)]);
    setCurrentDates([
      ...new Set(
        matches
          .filter((match) => match.matchDay === date)
          .map((cm) => {
            return cm.dateTimeLocal;
          })
      ),
    ]);
    setCurrentDate(date);
  };
  useEffect(() => {
    getMatches();
    getRanking();
  }, []);
  return (
    <div className="torneodetails">
      <Link to="/torneos" className="torneodetails__backBtn">
        <ArrowBackIosNewIcon />
      </Link>

      <h2 className="torneodetails__competitionTitle">{competitionName}</h2>
      <div className="torneodetails">
        <div className="torneodetails__content">
          <div className="torneodetails__fixture">
            <div className="torneodetails__subtitleContainer">
              <img src="/calendar_icon.png" alt="calendarIcon" />
              <h2>Fixture</h2>
            </div>

            <div className="torneodetails__matchdays">
              {matchDays.map((md) => (
                <Chip
                  id={md}
                  key={md}
                  color="info"
                  label={`Fecha ${md}`}
                  style={
                    currentDate === md
                      ? {
                          borderRadius: "8px",
                          border: "1px solid #393C71",
                          background: "rgba(57, 60, 113, 0.70)",
                        }
                      : {
                          borderRadius: "8px",
                          border: "1px solid #393C71",
                          background: "rgba(255, 255, 255, 0.00)",
                        }
                  }
                  clickable
                  className={
                    currentDate === md
                      ? "torneodetails__matchday-selected"
                      : "torneodetails__matchday"
                  }
                  size="medium"
                  onClick={() => handleChipClick(md)}
                />
              ))}
            </div>
            {currentDates.map((date) => {
              return (
                <>
                  <h4 className="torneodetails__date">
                    <img src="/acute_icon.png" alt="acuteIcon" /> {date}
                  </h4>
                  {currentMatches
                    .filter((match) => match.dateTimeLocal === date)
                    .map((match) => (
                      <span className="torneodetails__resultrow">
                        <p className="torneodetails__matchstatus">
                          {match.status === "PLAYED" && "TC"}
                          <img
                            className="torneodetails__homeImg"
                            alt="homeLogo"
                            src={`/content/teams/t_${match.homeTeamFifaId}.png`}
                          />
                        </p>

                        <p className="torneodetails__home">{match.home}</p>

                        <p className="torneodetails__homescore">
                          {match.homeScore}
                        </p>
                        <p className="torneodetails__hyphenseparator">-</p>
                        <p className="torneodetails__awayscore">
                          {match.awayScore}
                        </p>

                        <p className="torneodetails__away">{match.away}</p>
                        <img
                          className="torneodetails__awayImg"
                          alt="awayLogo"
                          src={`/content/teams/t_${match.awayTeamFifaId}.png`}
                        />
                      </span>
                    ))}
                </>
              );
            })}
          </div>
          {showPositions ? (
            <div className="torneodetails__positions">
              <div className="torneodetails__subtitleContainer">
                <StarIcon />
                <h2>Tabla de posiciones</h2>
              </div>
              {ranking.length > 0 && (
                <BasicTable
                  rows={[
                    ...ranking.map((row) => [
                      <img
                        className="torneodetails__teamImg"
                        src={`/content/teams/t_${row.teamFifaId}.png`}
                        alt="teamLogo"
                      />,
                      row.internationalShortName,
                      row.matchesPlayed,
                      row.wins,
                      row.draws,
                      row.losses,
                      row.goalDifference,
                      row.points,
                    ]),
                  ]}
                  columns={["", "Equipo", "PJ", "G", "E", "P", "DG", "PTS"]}
                />
              )}
            </div>
          ) : (
            <center>
              <p>
                Estamos experimentando inconvenientes en la carga de las
                posiciones. Estamos trabajando para solucionarlo a la brevedad
              </p>
            </center>
          )}
        </div>
      </div>
    </div>
  );
}

export default TorneoDetails;
